exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-img[data-v-72962cb0]{max-width:32px;border:.5px solid #667085}h2[data-v-72962cb0],p[data-v-72962cb0],span[data-v-72962cb0]{font-family:Karla;font-style:normal;color:#303941;font-weight:300;font-size:14px;line-height:16px}.title[data-v-72962cb0]{font-weight:500;font-size:20px;line-height:23px;color:#303941}.request-title[data-v-72962cb0]{text-decoration-line:underline}.v-label[data-v-72962cb0]{font-family:Karla;font-style:normal;font-weight:500;font-size:16px;line-height:19px;color:#303941}.v-list-item[data-v-72962cb0]{border:1px solid #eee}.notification-date[data-v-72962cb0]{font-size:10px;color:#667085}", ""]);

// exports
